document.addEventListener('DOMContentLoaded', function () {
  var popup = document.getElementById('chm-entry-popup');
  if (!popup) return;

  var STORAGE_KEY = 'chm_popup_seen';
  var alreadySeen = sessionStorage.getItem(STORAGE_KEY);

  if (!alreadySeen) {
    requestAnimationFrame(function () {
      popup.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
    });
  }

  var closeBtn = document.getElementById('chm-entry-popup-close');
  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      popup.classList.remove('is-visible');
      document.body.style.overflow = '';
      sessionStorage.setItem(STORAGE_KEY, '1');
    });
  }
});